<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">General</span>
        <h3 class="page-title">Notifications</h3>
      </div>
    </div>

    <d-card class="card-small user-activity mb-4">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <h6 class="m-0">Mes notifications</h6>
        <div class="block-handle"></div>
      </d-card-header>

      <!-- Activity Items -->
      <d-card-body class="p-0">
        <div
          class="user-activity__item pr-3 py-3"
          style="border-left:0!important;"
          v-for="(notification, index) in notifications"
          :key="index"
        >
          
          <div class="user-activity__item__content">
            <!-- Creation date + Status -->
            <div class="row">
              <span class="text-light d-flex align-items-center">{{
                formatDate(notification.creationDate)
              }}</span>
            </div>

            <div class="row">
              <p v-html="notification.message"></p> 
              <div 
                class="ml-md-3 row col-12 col-sm"
                v-if="notification.type === 'TASK'"
              >
               
                <div
                  v-if="notification.status.toLowerCase()==='pending'"
                >
                  <button class="ml-sm-2 status-pill-pending">
                    <span>À Faire</span>
                  </button>
                </div>
                <div
                  v-else
                >
                  <button class="ml-sm-2 status-pill-approved">
                    <span>Terminé</span>
                  </button>  
                </div>
              </div>
              <div
                class="ml-md-3 row col-12 col-sm"
                v-else-if= "notification.type != 'MINIBUS'"
              >
                <div class="d-flex align-items-center">
                </div>
                <!-- {{notification}} -->
                <div
                  v-if="notification.status.toLowerCase()==='pending'"
                >
                  <button class="ml-sm-2 status-pill-pending">
                    <span>En Attente</span>
                  </button>
                </div>
                <div
                  v-else-if="notification.status.toLowerCase()==='rejected' || notification.status.toLowerCase() ==='refused'"
                >
                  <button class="ml-sm-2 status-pill-rejected">
                    <span>Rejeté</span>
                  </button>
                </div>
                <div
                  v-else-if="notification.status.toLowerCase()==='accepted'"
                >
                  <button class="ml-sm-2 status-pill-approved">
                    <span>Approuvé</span>
                  </button>               
                </div>
                <div
                  v-else-if="notification.status.toLowerCase()==='modified'"
                >
                  <button class="ml-sm-2 status-pill-modified">
                    <span>Demande de modifications</span>
                  </button>               
                </div>
              </div>
            </div>
          </div>
         
          <div
            class="user-activity__item__action ml-auto"
            v-if="notification.action"
          >
            <button
              class="ml-auto btn btn-sm btn-white"
              @click="selectRoute(notification)"
            >
              {{ btnText(notification) }}
            </button>
          </div>
        </div>

        <!--
        <div class="user-activity__item pr-3 py-3">
          <div class="user-activity__item__icon">
            <i class="material-icons">&#xE5CA;</i>
          </div>
          <div class="user-activity__item__content">
            <span class="text-light">09/12/2019 à 10h32</span>
            <p>Tâche <a href="#">5-5321</a> est tagguée
              <d-badge pill outline theme="success">Complète</d-badge>
              par <a href="#">Jean Pierre</a>.
            </p>
          </div>
        </div>

        <div class="user-activity__item pr-3 py-3">
          <div class="user-activity__item__icon">
            <i class="material-icons">&#xE7FE;</i>
          </div>
          <div class="user-activity__item__content">
            <span class="text-light">09/12/2019 à 10h32</span>
            <p><a href="#">Luc Eude</a> a été ajouté au groupe Comptabilité.</p>
          </div>
          <div class="user-activity__item__action ml-auto">
            <button class="ml-auto btn btn-sm btn-white">Voir</button>
          </div>
        </div>

        <div class="user-activity__item pr-3 py-3">
          <div class="user-activity__item__icon">
            <i class="material-icons">&#xE868;</i>
          </div>
          <div class="user-activity__item__content">
            <span class="text-light">09/12/2019 à 10h32</span>
            <p>Lorem ipsum</p>
          </div>
        </div>

        <div class="user-activity__item pr-3 py-3">
          <div class="user-activity__item__icon">
            <i class="material-icons">&#xE065;</i>
          </div>
          <div class="user-activity__item__content">
            <span class="text-light">09/12/2019 à 10h32</span>
            <p>Lorem ipsum</p>
          </div>
        </div>
      -->
      </d-card-body>
    </d-card>
  </div>
</template>

<script>
import TimeUtils from '../../utils/TimeUtils';
import notificationsModel from '../../data/notifications/notifications';

export default {
  name: 'Notifications',

  async mounted() {
    await this.$services.notification.readAll();
    this.$store.commit('readAllNotifications');
    console.log("this is the log:", this.$store.state.user.notifications)
  },

  computed: {
    notifications() {
      return this.$store.state.user.notifications;
    },

    user() {
      return this.$store.state.user.informations;
    },
  },

  methods: {
    formatDate(date) {
      return TimeUtils.formatDateTime(date);
    },
    borderSelection(notification) {
      if (notification.action && notification.status == 'PENDING') {
        return 'border-warning';
      } else if (notification.action && notification.status == 'ACCEPTED') {
        return 'border-success';
      }

      return 'border-light';
    },

    iconFormat(notification) {
      return notification.absenceId && notification.status != 'PENDING'
        ? notificationsModel.ACTION_PERFORMED.icon
        : notificationsModel[notification.type].icon;
    },

    titleFormat(notification) {
      return notification.absenceId && notification.status != 'PENDING'
        ? notificationsModel.ACTION_PERFORMED.title
        : notificationsModel[notification.type].title;
    },

    btnText(notification) {
      return notification.type == 'TASK'
        ? 'Afficher la tâche'
        : 'Voir la demande';
    },

    selectRoute(notification) {
      let route = '';
      if (notification.type == 'TASK') {
        route =
          notification.taskCreatedBy == this.user.reference
            ? `/tasks/${notification.action}`
            : `/personalTasks/${notification.action}`;
      } else {
        route = notification.action;
      }
      this.$router.push(route);
    },
  },
};
</script>

<style >
i.material-icons {
  top: 0px !important;
}
i.material-icons {
  position: relative;
  top: 0px !important;
}

.status-pill-modified {
  border: 1px solid #78756D;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  border-radius: 5px;
  padding: 0;
}
.status-pill-modified span {
  display: block;
  width: 150px;
  border-radius: 5px;
  padding: 5px 15px;
  font-weight: 700;
  background-color: #E0DFDD;
  color: #78756D;
}
</style>
